var _a;

import { ErrorSource, RawReportType, getFileFromStackTraceString, initReportObservable } from '@datadog/browser-core';
import { StatusType } from '../../logger';
var LogStatusForReport = (_a = {}, _a[RawReportType.cspViolation] = StatusType.error, _a[RawReportType.intervention] = StatusType.error, _a[RawReportType.deprecation] = StatusType.warn, _a);
export function startReportCollection(configuration, sender) {
  var reportObservable = initReportObservable(configuration.forwardReports);
  var reportSubscription = reportObservable.subscribe(logReport);

  function logReport(report) {
    var message = report.message;
    var messageContext = {
      origin: ErrorSource.REPORT
    };
    var logStatus = LogStatusForReport[report.type];

    if (logStatus === StatusType.error) {
      messageContext.error = {
        kind: report.subtype,
        origin: ErrorSource.REPORT,
        stack: report.stack
      };
    } else if (report.stack) {
      message += " Found in ".concat(getFileFromStackTraceString(report.stack));
    }

    sender.sendToHttp(message, messageContext, logStatus);
  }

  return {
    stop: function stop() {
      reportSubscription.unsubscribe();
    }
  };
}